module.exports = __webpack_public_path__ + "img/icon-check.161aa6bd.svg";